import '/assets/styles/sections/home/hero.scss';

// Partials
import Btn from '/views/partials/btn';

const Hero = () => (
  <section id="hero" className="section home-hero">
    <div className="hero-wrap wrapper">
      <h1 className="hero-title">
        Event Tech, <span>Simplified</span>
      </h1>

      <p className="hero-subtitle wrapper inner narrower">
        Incy provides seamless integration for ticketing, payments, and analytics, empowering events of any size to thrive with minimal effort.
      </p>

      <div className="hero-controls">
        <Btn
          tag="a"
          href="#incy-pay"
          className="controls-btn big primary">
          Explore Features
        </Btn>
        <Btn
          tag="a"
          href="#contact"
          className="controls-btn big white">
          Request a Demo
        </Btn>
      </div>
    </div>
  </section>
)

export default Hero;